import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    max:  { type: Number, default: 3 },
    message: String
  }

  static targets = [
    "checkbox",
    "files",
    "save"
  ]

  connect() {
    this.saveTarget.addEventListener(
      "click",
      this.checkBeforeSubmit.bind(this)
    )
  }

  /**
   * Prevents form submission if total selected items exceed maxValue
   * @param {Event} event
   */
  checkBeforeSubmit(event) {
    const selectedBoxes = this.checkboxTargets.filter(cb => cb.checked).length
    const selectedFiles = this.filesTarget.files.length
    const totalSelected = selectedBoxes + selectedFiles

    if (totalSelected > this.maxValue) {
      event.preventDefault()
      const msg = this.messageValue.replace("%{max}", this.maxValue)
      window.helpers.notify(msg, { type: "error" })
    } else {
      window.helpers.closeDialogs()
      this.dispatch("clear", { bubbles: true })
    }
  }
}
